(function(root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.RandesLodgingCalculator = api;
})(typeof window !== 'undefined' ? window : globalThis, function() {
  'use strict';

  function decodeHtml(value) {
    var source = String(value || '');
    if (typeof document !== 'undefined') {
      var textarea = document.createElement('textarea');
      textarea.innerHTML = source;
      return textarea.value;
    }
    return source
      .replace(/&nbsp;|&#160;/gi, ' ')
      .replace(/&#36;|&#x24;/gi, '$')
      .replace(/&amp;/gi, '&')
      .replace(/&lt;/gi, '<')
      .replace(/&gt;/gi, '>')
      .replace(/&quot;/gi, '"')
      .replace(/&#39;|&apos;/gi, "'");
  }

  function plainText(html) {
    return decodeHtml(String(html || '')
      .replace(/<br\s*\/?>/gi, ' ')
      .replace(/<[^>]+>/g, ' '))
      .replace(/\s+/g, ' ')
      .trim();
  }

  function pricingSection(descriptionHtml) {
    var html = String(descriptionHtml || '');
    var headingPattern = /<h([1-6])\b[^>]*>([\s\S]*?)<\/h\1>/gi;
    var heading;
    while ((heading = headingPattern.exec(html)) !== null) {
      if (/tabla\s+de\s+precios?|price\s+table|pricing\s+table|rates/i.test(plainText(heading[2]))) break;
    }
    if (!heading) return html;
    var afterHeading = html.slice(heading.index + heading[0].length);
    var nextHeading = /<h[1-6]\b/i.exec(afterHeading);
    return nextHeading ? afterHeading.slice(0, nextHeading.index) : afterHeading;
  }

  function numericPrice(value) {
    var source = String(value == null ? '' : value).trim();
    var normalized;
    if (/^\d+$/.test(source)) normalized = source;
    else if (/^\d{1,3}([.,])\d{3}(?:\1\d{3})*$/.test(source)) normalized = source.replace(/[.,]/g, '');
    else if (/^(?:\d+|\d{1,3}(?:,\d{3})+)\.\d{2}$/.test(source)) normalized = source.replace(/,/g, '');
    else if (/^(?:\d+|\d{1,3}(?:\.\d{3})+),\d{2}$/.test(source)) normalized = source.replace(/\./g, '').replace(',', '.');
    else return 0;
    // Las tarifas publicadas se cobran en pesos COP enteros. Un formato ambiguo
    // o fraccionario requiere consulta; nunca eliminar separadores a ciegas.
    var number = Number(normalized);
    return Number.isSafeInteger(number) && number > 0 ? number : 0;
  }

  function normalizeUnit(value) {
    var unit = plainText(value).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, ' ').trim();
    var units = {
      'per_person': 'per_person', 'por persona': 'per_person', 'per person': 'per_person',
      'per_room': 'per_room', 'por habitacion': 'per_room', 'per room': 'per_room',
      'per_night': 'per_night', 'por noche': 'per_night', 'per night': 'per_night',
      'per_booking': 'per_booking', 'por reserva': 'per_booking', 'per booking': 'per_booking',
      'per_person_night': 'per_person_night', 'por persona/noche': 'per_person_night',
      'por persona por noche': 'per_person_night', 'per person/night': 'per_person_night', 'per person per night': 'per_person_night'
    };
    return units[unit] || (unit ? 'unknown' : 'per_person');
  }

  function parseRow(rowHtml) {
    var row = plainText(rowHtml);
    if (!/\b(?:personas?|people|persons?)\b/i.test(row)) return null;
    if (/\b(?:USD|EUR|US\s*\$)\b|€|per room|por habitaci[oó]n/i.test(row)) return null;
    var priceMatch = row.match(/(?:COP\s*\$?|\$)\s*([\d.,]+)/i) || row.match(/([\d.,]+)\s*(?:pesos|cop)\b/i);
    var price = numericPrice(priceMatch && priceMatch[1]);
    if (!price) return null;

    var range = row.match(/(\d+)\s*(?:a|al|hasta|to|through|[-–—])\s*(\d+)\s*(?:personas?|people|persons?)\b/i);
    if (range) {
      var min = Number(range[1]);
      var max = Number(range[2]);
      if (min > 0 && max >= min) return { min: min, max: max, pricePerPerson: price, label: row };
    }

    var open = row.match(/(\d+)\s*(?:personas?|people|persons?)\s*(?:(?:o|y)\s*m[aá]s|(?:or|and)\s*more|\+)/i) || row.match(/(\d+)\s*\+\s*(?:personas?|people|persons?)\b/i);
    if (open && Number(open[1]) > 0) return { min: Number(open[1]), max: null, pricePerPerson: price, label: row };

    if (range || open) return null;
    var exact = row.match(/(\d+)\s*(?:personas?|people|persons?)\b/i);
    if (exact) {
      var quantity = Number(exact[1]);
      if (quantity > 0) return { min: quantity, max: quantity, pricePerPerson: price, label: row };
    }
    return null;
  }

  function parsePricingHtml(descriptionHtml) {
    var section = pricingSection(descriptionHtml);
    var rows = [];
    var listItemPattern = /<li\b[^>]*>([\s\S]*?)<\/li>/gi;
    var match;
    while ((match = listItemPattern.exec(section)) !== null) rows.push(match[1]);
    if (!rows.length) {
      var tableRowPattern = /<tr\b[^>]*>([\s\S]*?)<\/tr>/gi;
      while ((match = tableRowPattern.exec(section)) !== null) rows.push(match[1]);
    }
    if (!rows.length) rows = section.split(/<br\s*\/?>|<\/p>|\n/gi);

    var rates = rows.map(parseRow).filter(Boolean);
    rates.sort(function(a, b) {
      if (a.min !== b.min) return a.min - b.min;
      if (a.max === b.max) return 0;
      if (a.max === null) return 1;
      if (b.max === null) return -1;
      return a.max - b.max;
    });
    return rates;
  }

  function rateFor(rates, quantity) {
    var count = Number(quantity);
    if (!Number.isInteger(count) || count < 1) return null;
    var candidates = (rates || []).filter(function(rate) {
      return count >= rate.min && (rate.max === null || count <= rate.max);
    });
    candidates.sort(function(a, b) {
      var aExact = a.min === count && a.max === count;
      var bExact = b.min === count && b.max === count;
      if (aExact !== bExact) return aExact ? -1 : 1;
      var aSpan = a.max === null ? Number.MAX_SAFE_INTEGER : a.max - a.min;
      var bSpan = b.max === null ? Number.MAX_SAFE_INTEGER : b.max - b.min;
      return aSpan - bSpan;
    });
    return candidates[0] || null;
  }

  function availableQuantities(rates, capacity) {
    var maxCapacity = Number(capacity);
    var quantities = [];
    if (Number.isInteger(maxCapacity) && maxCapacity > 0) {
      for (var count = 1; count <= maxCapacity; count += 1) {
        if (rateFor(rates, count)) quantities.push(count);
      }
      return quantities;
    }
    (rates || []).forEach(function(rate) {
      var max = rate.max === null ? rate.min : rate.max;
      for (var count = rate.min; count <= max; count += 1) {
        if (quantities.indexOf(count) === -1) quantities.push(count);
      }
    });
    return quantities.sort(function(a, b) { return a - b; });
  }

  function quote(rates, quantity, nights) {
    var rate = rateFor(rates, quantity);
    var nightCount = Number(nights);
    if (!rate || !Number.isInteger(nightCount) || nightCount < 1) return null;
    var total = Number(quantity) * nightCount * rate.pricePerPerson;
    if (!Number.isSafeInteger(total) || total <= 0) return null;
    var deposit = Math.round(total * 0.4);
    return {
      quantity: Number(quantity),
      nights: nightCount,
      pricePerPerson: rate.pricePerPerson,
      total: total,
      deposit: deposit,
      balance: total - deposit
    };
  }

  // Locale SOLO para separadores de miles. La moneda es siempre COP con "$":
  // el negocio cobra en pesos, el símbolo no cambia con el idioma. Defensivo
  // ante entornos sin DOM (este módulo UMD también corre en Node para pruebas).
  function moneyLocale() {
    try {
      var lang = (typeof document !== 'undefined' && document.documentElement.getAttribute('lang') || 'es').toLowerCase();
      return lang.indexOf('en') === 0 ? 'en-US' : 'es-CO';
    } catch (e) {
      return 'es-CO';
    }
  }

  function formatMoney(value) {
    var amount = Number(value);
    if (!Number.isFinite(amount)) return '';
    return '$' + Math.round(amount).toLocaleString(moneyLocale());
  }

  return {
    numericPrice: numericPrice,
    normalizeUnit: normalizeUnit,
    parsePricingHtml: parsePricingHtml,
    availableQuantities: availableQuantities,
    rateFor: rateFor,
    quote: quote,
    formatMoney: formatMoney
  };
});
